import { render, staticRenderFns } from "./homeConfig.vue?vue&type=template&id=2e0b3059"
import script from "./homeConfig.vue?vue&type=script&lang=js"
export * from "./homeConfig.vue?vue&type=script&lang=js"
import style0 from "./homeConfig.vue?vue&type=style&index=0&id=2e0b3059&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports